import React from "react";
import { LOGO_URL } from "../../config";
import "./Footer.css";

const NAV = ["home","episodes","blog","guests","live","about","contact"];

export default function Footer({ setPage, aboutData = {} }) {
  const socials = [
    { label: "YouTube",    url: aboutData.youtube   },
    { label: "Spotify",    url: aboutData.spotify   },
    { label: "Facebook",   url: aboutData.facebook  },
    { label: "Instagram",  url: aboutData.instagram },
    { label: "X / Twitter",url: aboutData.twitter   },
  ].filter((s) => s.url);

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">

          <div className="footer-brand">
            <img src={LOGO_URL} alt="Logo" />
            <p>
              Let's Talk LLC presents Talk News — the Kedrick Scribner Network.
              Real conversations about law enforcement, justice, and the issues
              shaping America and the world.
            </p>
          </div>

          <div className="footer-col">
            <h4>Navigate</h4>
            <ul>
              {NAV.map((n) => (
                <li key={n}>
                  <button onClick={() => setPage(n)}>
                    {n.charAt(0).toUpperCase() + n.slice(1)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Connect</h4>
            <ul>
              {socials.map((s) => (
                <li key={s.label}>
                  <a href={s.url} target="_blank" rel="noopener noreferrer">
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Let's Talk LLC · Kedrick Scribner Network. All rights reserved.</span>
          <span className="footer-brand-name">TALK NEWS</span>
        </div>
      </div>
    </footer>
  );
}
